import FormLogin, { FormSubmit } from 'components/formLogin/FormLogin';
import { ReduxProps } from '../../../models/ReduxProps';
import React from 'react';
import GeolocationModel from 'stores/login/models/login/GeolocationModel';
import LoginAction from 'stores/login/LoginAction';
import IStore from 'models/IStore';
import { connect } from 'react-redux';
import { selectRequesting } from 'selectors/requesting/RequestingSelector';
import { selectRawErrors } from 'selectors/error/ErrorSelector';
import ValidateAccountModel from 'stores/login/models/login/ValidateAccountModel';
import { redirectOnError } from 'helpers/Redirector';
import HandshakeModel from 'stores/handshake/models/HandshakeModel';
import UserAuthenticatedModel from 'stores/login/models/login/UserAuthenticatedModel';
import ErrorAction from 'stores/error/ErrorAction';

interface IState {
    loadingGeo: boolean;
    username: string;
    password: string;
    token: string;
    submitted: boolean;
    errorPassword: boolean;
}

interface IStateToProps {
    readonly isRequestingValidate: boolean;
    readonly isRequestingAuth: boolean;
    readonly account: ValidateAccountModel | null;
    readonly validateRawErrors: any;
    readonly authRawErrors: any;
    readonly geolocation: GeolocationModel;
    readonly handshake: HandshakeModel | null;
    readonly storedUsername: string | undefined;
    readonly user: UserAuthenticatedModel | null;
    readonly currentComponent: any;
    readonly smallLogo: string | undefined;
    readonly errorRaw: any;
}
const mapStateToProps = (state: IStore): IStateToProps => ({
    isRequestingValidate: selectRequesting(state, [LoginAction.REQUEST_VALIDATE_ACCOUNT]),
    isRequestingAuth: selectRequesting(state, [LoginAction.REQUEST_AUTHENTICATE]),
    validateRawErrors: selectRawErrors(state, [LoginAction.REQUEST_VALIDATE_ACCOUNT_FINISHED]),
    authRawErrors: selectRawErrors(state, [LoginAction.REQUEST_AUTHENTICATE_FINISHED]),
    account: state.login.account,
    geolocation: state.login.geolocation,
    handshake: state.handshake.handshake,
    storedUsername: state.login.username,
    user: state.login.user,
    currentComponent: state.login.currentComponent,
    smallLogo: state.handshake?.handshake?.assets?.logoValiuSmall,
    errorRaw: state.error,
});

class AuthContainer extends React.Component<{} & IStateToProps & ReduxProps<any>, IState> {
    constructor(props: any) {
        super(props);
        this.state = {
            loadingGeo: false,
            username: '',
            password: '',
            token: '',
            submitted: false,
            errorPassword: false,
        };
        this.onSubmitData = this.onSubmitData.bind(this);
    }

    validateAccountWGeo(username: string) {
        this.setState({ loadingGeo: true });
        if (!navigator.geolocation) {
            // User disable geolocation support on their browser o browser doesn't support it
            console.log('Geolocation is not supported by your browser');
            this.setState({ loadingGeo: false });
            this.props.dispatch(LoginAction.SetGeoIsBlocked());
        } else {
            // Get geolocation
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    this.setState({
                        loadingGeo: false,
                    });
                    if (position && position.coords) {
                        const storedGeo = {
                            altitude: position.coords.altitude || 0,
                            latitude: position.coords.latitude || 0,
                            longitude: position.coords.longitude || 0,
                        };

                        // SetGeolocation set isBlocked to true internally
                        this.props.dispatch(LoginAction.SetGeolocation(storedGeo));
                        this.props.dispatch(LoginAction.requestValidateAccount(username));
                    } else {
                        this.setState({ loadingGeo: false });
                        this.props.dispatch(LoginAction.SetGeoIsBlocked());
                    }
                },
                (err) => {
                    console.log('Unable to retrieve your location', err);
                    this.setState({ loadingGeo: false });
                    this.props.dispatch(LoginAction.SetGeoIsBlocked());
                }
            );
        }
    }

    onSubmitData(data: FormSubmit) {
        this.setState({ username: data.username, password: data.password, token: data.token });
        this.validateAccountWGeo(data.username);
    }

    // Execute authentication endpoint
    componentWillReceiveProps(nextProps: any) {
        const { username, password, token, submitted } = this.state;
        const { geolocation, account, user, isRequestingValidate, isRequestingAuth, storedUsername, currentComponent } = nextProps;

        if (account && user === null && !isRequestingValidate && !isRequestingAuth && !submitted) {
            if (username && password && token && geolocation && geolocation.userConsent && !geolocation.isBlocked) {
                if (!storedUsername && currentComponent === 'validateAccount') {
                    this.setUserNameValidated(username);
                } else {
                    const stringGeo = `${geolocation.latitude || 0},${geolocation.longitude || 0},${geolocation.altitude || 0}`;
                    this.setState({ submitted: true });
                    this.props.dispatch(LoginAction.requestAuthenticate(password, token, stringGeo));
                }
            }
        }
    }

    serializeRawErrors(validate: any, auth: any) {
        const { handshake } = this.props;
        const validateError = validate[LoginAction.REQUEST_VALIDATE_ACCOUNT_FINISHED] || undefined;
        const authError = auth[LoginAction.REQUEST_AUTHENTICATE_FINISHED] || undefined;

        if (validateError) {
            var raw = validateError.raw;
            if (raw.data && raw.data.userName !== undefined) {
                return raw.data.userName[0];
            } else if (raw.data.message !== undefined) {
                return raw.data.message[0];
            } else {
                // Código duro
                return `Hay un error en la aplicación, favor de intentar más adelante o contacta a nuestro centro de atención al cliente.`;
            }
        } else {
            if (authError && handshake && handshake.loginUrls) {
                const raw = authError.raw;

                if (raw.data.message !== undefined && raw.data.message[0].includes('es incorrecta. Por favor verifique e intente nuevamente.')) {
                    if (!this.state.errorPassword) {
                        this.setState({
                            errorPassword: true,
                            loadingGeo: false,
                            submitted: false,
                            username: '',
                            password: '',
                            token: '',
                        });
                    }

                    return '*Verifica tus datos y vuelve a intentar.';
                }

                if (raw.data && raw.data.message !== undefined) {
                    // TODO: Cambiar el 204 por el codigo que regrese el server
                    window.location.href = redirectOnError(handshake.loginUrls.onErrorRedirect, raw.data.message[0], '204');
                } else {
                    window.location.href = redirectOnError(handshake.loginUrls.onErrorRedirect, '', '500');
                }
            }
        }
    }

    render() {
        const { submitted } = this.state;
        const { validateRawErrors, authRawErrors, isRequestingValidate, account, isRequestingAuth, user, geolocation } = this.props;
        const messageError = this.serializeRawErrors(validateRawErrors, authRawErrors);
        const loadingSubmit = (isRequestingValidate && account === null) || (isRequestingAuth && user === null) || this.state.loadingGeo;

        return (
            <div className="box-container">
                <div className="login-container-box">
                    <div className="box-welcome">
                        <div className="img-container">
                            <img alt="welcome" src={this.props.smallLogo} />
                        </div>
                        <div className="text">Bienvenido</div>
                    </div>
                    <div className="box-login" id="box-loginid">
                        <FormLogin
                            hanldeSubmitLogin={(data) => this.onSubmitData(data)}
                            loadingSubmit={loadingSubmit || submitted}
                            isGeolocation={geolocation.userConsent}
                            messageError={messageError}
                            errorPassword={this.state.errorPassword}
                            handleChangeErrorPassword={() => {
                                if (Object.keys(this.props.errorRaw).length) {
                                    this.props.dispatch(ErrorAction.clearAll());
                                    this.props.dispatch(LoginAction.ResetUsername());
                                    this.props.dispatch(LoginAction.ResetAccount());
                                    this.props.dispatch(LoginAction.SetCurrentComponent('validateAccount'));
                                }

                                if (this.state.errorPassword) {
                                    this.setState({ errorPassword: false });
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        );
    }

    setUserNameValidated(username: string) {
        this.props.dispatch(LoginAction.ActualizeUsername(username));
        this.props.dispatch(LoginAction.SetCurrentComponent('authentication'));
    }
}

export { AuthContainer as Unconnected };
export default connect(mapStateToProps)(AuthContainer);
